import { render } from "./AllInsurance.vue?vue&type=template&id=69ba466f"
import script from "./AllInsurance.vue?vue&type=script&lang=js"
export * from "./AllInsurance.vue?vue&type=script&lang=js"

import "./AllInsurance.vue?vue&type=style&index=0&id=69ba466f&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/insurances/AllInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69ba466f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69ba466f', __exports__)) {
    console.log('reload')
    api.reload('69ba466f', __exports__)
  }
  
  module.hot.accept("./AllInsurance.vue?vue&type=template&id=69ba466f", () => {
    console.log('re-render')
    api.rerender('69ba466f', render)
  })

}


export default __exports__